export const UPCOMING = 'upcoming';
export const LIVE = 'live';
export const COMPLETED = 'completed';
